import { Component, OnInit, input } from '@angular/core';
import {
  ApplyPanelComponent,
  ColorPickerComponent,
  NumberInputComponent,
  TextInputComponent,
} from '@imagise/shared';
import { TranslateModule } from '@ngx-translate/core';
import { EditMode } from '../../../domain/enums/editor.enum';
import { EditorWatermarkDraftOperation } from '../../../domain';
import { Size2D } from '../../../domain/interfaces/shared';
import { EditOptionsPanelBase } from '../edit-options-panel.base';
import { PanelLayoutComponent } from '../panel-layout/panel-layout.component';
import {
  AVAILABLE_WATERMARK_FONT_NAMES,
  DEFAULT_WATERMARK_FONT_NAME,
  // normalizeWatermarkFontName,
} from '../../../domain/models/watermark-fonts';

const DEFAULT_WATERMARK_TEXT = '';
const DEFAULT_WATERMARK_TEXT_COLOR = '#000000';
const DEFAULT_WATERMARK_FONT_SIZE = 24;
const DEFAULT_WATERMARK_ROTATION = -45;

@Component({
  selector: 'lib-watermark-panel',
  host: {
    class: 'contents',
  },
  templateUrl: './watermark-panel.component.html',
  styleUrls: ['./watermark-panel.component.scss'],
  imports: [
    ApplyPanelComponent,
    ColorPickerComponent,
    NumberInputComponent,
    PanelLayoutComponent,
    TextInputComponent,
    TranslateModule,
  ],
})
export class WatermarkPanelComponent extends EditOptionsPanelBase<EditorWatermarkDraftOperation> implements OnInit {
  readonly imageSize = input<Size2D | null>(null);

  text = DEFAULT_WATERMARK_TEXT;
  textColor = DEFAULT_WATERMARK_TEXT_COLOR;
  fontName = DEFAULT_WATERMARK_FONT_NAME;
  fontSize = DEFAULT_WATERMARK_FONT_SIZE;
  rotationAngleDegrees = DEFAULT_WATERMARK_ROTATION;
  readonly availableFontNames = AVAILABLE_WATERMARK_FONT_NAMES;

  ngOnInit(): void {
    this.emitWatermarkOptions();
  }

  onTextChanged(value: string): void {
    this.text = value;
    this.emitWatermarkOptions();
  }

  onTextColorChanged(value: string): void {
    this.textColor = value;
    this.emitWatermarkOptions();
  }

  // Temporarily disabled: font selection will be restored after backend
  // exposes available fonts list for frontend.
  // onFontNameChanged(event: Event): void {
  //   this.fontName = (event.target as HTMLInputElement).value;
  //   this.emitWatermarkOptions();
  // }

  onFontSizeChanged(value: number): void {
    this.fontSize = value;
    this.emitWatermarkOptions();
  }

  onRotationChanged(value: number): void {
    this.rotationAngleDegrees = value;
    this.emitWatermarkOptions();
  }

  protected refresh(): void {
    this.text = DEFAULT_WATERMARK_TEXT;
    this.textColor = DEFAULT_WATERMARK_TEXT_COLOR;
    this.fontName = DEFAULT_WATERMARK_FONT_NAME;
    this.fontSize = DEFAULT_WATERMARK_FONT_SIZE;
    this.rotationAngleDegrees = DEFAULT_WATERMARK_ROTATION;
    this.emitWatermarkOptions();
  }

  private emitWatermarkOptions(): void {
    const fontName = DEFAULT_WATERMARK_FONT_NAME;
    // const fontName = this.fontName;

    this.changed.emit({
      kind: 'watermark',
      mode: EditMode.Watermark,
      params: {
        text: this.text,
        textColor: this.textColor,
        fontName,
        fontSize: this.fontSize,
        rotationAngleDegrees: this.rotationAngleDegrees,
      },
    });
  }
}
